import { PlanCard } from ".";

export const PlanCards = () => {
  return (
    <>
      <PlanCard
        title={"Básico"}
        subTitle={"R$0 / mês (grátis)"}
        description={
          "Como um usuário gratuito você tem direito a 5 perguntas por dia para ajudá-lo"
        }
        button={"Comece agora grátis"}
        list={[
          "5 perguntas por dia",
          "Sem histórico de interações",
          "Perguntas públicas",
        ]}
        type="primary"
        pathName="hero7.jpg"
        width="20%"
        height="20%"
      ></PlanCard>

      <PlanCard
        title={"Premium"}
        subTitle={"R$9,99 / mês"}
        description={
          "Apoie o desenvolvimento da OP Club e tenha acesso a perguntas ilimitadas"
        }
        button={"Assine agora"}
        list={["Histórico de interações", "Pro Builds", "Perguntas privadas"]}
        type="primary"
        pathName="hero17.jpg"
        width="20%"
        height="20%"
      ></PlanCard>

      <PlanCard
        title={"OP Club+"}
        subTitle={"R$24,99 / mês"}
        description={
          "O treinador virtual aprende com seu histórico e atua para melhorar o seu jogo"
        }
        button={"Em breve"}
        list={[
          "Treinador AI",
          "Aumente a sua playformance",
          "Desenvolvido por profissionais",
        ]}
        type="secondary"
        pathName="hero10.png"
        width="20%"
        height="20%"
      ></PlanCard>
      {/* <Heading variant={"h3"}>Plano <label style={styles.label}>PRO</label></Heading> */}
      {/* <Card3 title={"Crie seu próprio assistente em AI"} subTitle={"Tenha acesso ao nosso centro de treinamento e treine o modelo do seu jeito!"} value={["R$99,99/mês","R$49,99/mês"]} button={"Entrar em contato!"} style={{height: "65%"}}></Card3>         */}
      {/* <Card4 list={["Acesso ao centro de treinamento da AI","Crie seu próprio assistente AI de um jeito simples","Escale o alcance do seu conhecimento", "De forma fácil, rápida e lucrativa", "Negocie o seu modelo em nosso marketplace [em breve]"] }></Card4> */}
    </>
  );
};
